import React, { useMemo } from "react";
import { FilterList, FilterListItem } from "./FilterList";
import { ProductType } from "../../../interfaces/DTO/mislaka_xml_models";
import { getSubspecializationColor } from "../../../utils/fundsFormatter";

interface SubSpecializationsFilterListProps {
  productType: ProductType;
  selectedSubSpecializations: string[];
  onToggle: (subSpec: string) => void;
  pinnedSubSpecializations?: string[];
  onTogglePin?: (subSpec: string) => void;
  colorByMode?: string;
  onColorByToggle?: () => void;
}

export const SubSpecializationsFilterList: React.FC<
  SubSpecializationsFilterListProps
> = ({ productType, selectedSubSpecializations, onToggle, pinnedSubSpecializations, onTogglePin, colorByMode, onColorByToggle }) => {
  const items: FilterListItem[] = useMemo(() => {
    const { fundService } = require("../../../services/fundService");
    const fundsForProduct = fundService.getFundsFromCacheByCriteria({
      productType,
    });
    const uniqueSpecs = [
      ...new Set(
        fundsForProduct.map((f: any) => f.sub_specialization || "-")
      ),
    ] as string[];
    const sortedSpecs = uniqueSpecs.sort();

    return sortedSpecs.map((spec) => ({
      value: spec,
      label: spec,
      color: getSubspecializationColor(spec),
    }));
  }, [productType]);

  return (
    <FilterList
      items={items}
      selectedValues={selectedSubSpecializations}
      onToggle={onToggle}
      showColorIndicator={true}
      title="התמחויות"
      pinnedValues={pinnedSubSpecializations}
      onTogglePin={onTogglePin}
      colorByMode={colorByMode}
      onColorByToggle={onColorByToggle}
      colorByValue="subspecialization"
    />
  );
};
